export const QuoteStage = {
  ACTIVE: 'ACTIVE',
};
